<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="d-flex flex-column align-self-center mr-auto">
        <div class="secondary--text pl-3 titre-h3">
          {{ libelleGraine }}
        </div>
        <div class="texte-gris-fonce pl-3 intro">
          {{ libelleCritere }}
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-4 mx-4">
      <AgrialInputNumber
        v-model="minimum"
        class="input-number"
        label="Min"
        min="0"
        :suffix="unite"
      />
    </div>
    <div class="d-flex flex-column mx-4">
      <AgrialInputNumber
        v-model="valeurParDefaut"
        class="input-number"
        label="Défaut *"
        :rules="[rules.required]"
        min="0"
        :suffix="unite"
      />
    </div>
    <div class="d-flex flex-column mx-4">
      <AgrialInputNumber
        v-model="maximum"
        class="input-number"
        label="Max"
        min="0"
        :suffix="unite"
      />
    </div>
    <div class="mb-6 ml-5 action texte-gris-fonce">
      * Champ obligatoire
    </div>

    <BaseMessage
      v-if="erreur"
      class="mb-4 mx-5"
      color="error"
      :message="erreur"
      text
      type="error"
    />
    <BaseMessage
      v-if="donneesInvalides"
      class="mb-4 mx-5"
      color="error"
      :message="donneesInvalides"
      text
      type="error"
    />
    <div class="d-flex justify-space-around">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        :loading="loading"
        class="pa-5"
        @click="saveParametre()"
      >
        Valider
      </AgrButton>
    </div>
    <div class="d-flex">
      <BaseMessage
        class="my-4 mx-5"
        color="secondary"
        text
        :message="messageUpdateItem"
        type="info"
      />
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import BaseMessage from '@/components/common/base-message.vue'
import {clone} from '@/utils/clone'
import { format } from 'date-fns'
import {mapActions} from 'vuex'

export default {
  name: 'UpdateParametreSimulateurModal',
  components: {AgrButton, AgrialInputNumber, BaseMessage},
  props: {
    parametre: {
      type: Object,
      default: null
    },
    libelleGraine: {
      type: String,
      default: null
    },
    libelleCritere: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      parametreModifiable: {},
      loading: false,
      erreur: null,
      minimum: null,
      valeurParDefaut: null,
      maximum: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis'
      }
    }
  },

  computed: {
    isValid () {
      return this.valeurParDefaut != null && this.donneesInvalides == null
    },
    unite () {
      return this.libelleCritere ==='Rendement' ? 'qx/ha' : '€/ha'
    },
    donneesInvalides () {
      let result = null
      if (this.valeurParDefaut != null && this.minimum != null && this.minimum > this.valeurParDefaut) {
        result = 'Le champ Min doit être <= champ Défaut'
      }
      if (this.valeurParDefaut != null && this.maximum != null && this.maximum < this.valeurParDefaut) {
        result = 'Le champ Max doit être >= champ Défaut'
      }
      return result
    },
    messageUpdateItem () {
      return `Dernière modification : ${this.parametreModifiable.userDerniereModification} le ${format(new Date(this.parametreModifiable.dateDerniereModification), 'dd/MM/yyyy à HH:mm:ss') } `
    }
  },

  created () {
    this.parametreModifiable = clone(this.parametre)
    this.minimum = this.parametreModifiable.minimum
    this.valeurParDefaut = this.parametreModifiable.valeurParDefaut
    this.maximum = this.parametreModifiable.maximum
  },

  methods: {
    ...mapActions({
      update: 'reperesEconomiques/updateRepereEconomiqueItem'
    }),
    saveParametre () {
      this.loading = true
      this.erreur = null
      this.parametreModifiable.minimum = this.minimum
      this.parametreModifiable.valeurParDefaut = this.valeurParDefaut
      this.parametreModifiable.maximum = this.maximum
      this.update(this.parametreModifiable)
        .then(() => {
          this.$emit('close')
        })
        .catch(err => {
          this.erreur = err.response.data.message
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClose () {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
